import axios from "axios";
import { getAccessToken, getOidcManager, renewTokens } from "./oidc";

export const axiosClient = axios.create({
   headers: {
      Accept: "application/json",
   },
});

axiosClient.interceptors.request.use(async (config) => {
   config.metadata = { startTime: new Date() };
   const accessToken = await getAccessToken();
   if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
   }
   return config;
});

axiosClient.interceptors.response.use(
   (response) => {
      if (response && response.data) {
         return response.data;
      }
   },
   async (error) => {
      const originalRequest = error.config;
      if (error.response?.status === 401 && !originalRequest._retry) {
         originalRequest._retry = true;
         try {
            const user = await renewTokens();
            if (user?.access_token) {
               originalRequest.headers.Authorization = `Bearer ${user.access_token}`;
               return axiosClient(originalRequest);
            }
         } catch (renewError) {
            // Token renewal failed (e.g. invalid audience), redirect to login
            const manager = getOidcManager();
            if (manager) {
               await manager.signinRedirect({
                  state: {
                     returnTo: `${window.location.pathname}${window.location.search}${window.location.hash}`,
                  },
               });
            }
            return Promise.reject(renewError);
         }
      }
      return Promise.reject(error);
   }
);
